<template>
  <div class="flex flex-row h-10 mt-2">
    <div class="bg-bkk-50 rounded-full p-1 flex w-full justify-between">
      <button
        :class="[
          ' py-1 rounded-full transition-colors duration-200 text-sm px-10 sm:px-20 xl:px-28',
          currentView === FeedTabType.TAB_DISCOVERY
            ? 'bg-white border border-light-gray'
            : 'border-light-gray',
        ]"
        @click="setTab(FeedTabType.TAB_DISCOVERY)"
      >
        {{ t("feed.tab.switch.explore") }}
      </button>
      <button
        :class="[
          'py-1 rounded-full transition-colors duration-200 text-sm px-10 sm:px-20 xl:px-28',
          currentView === FeedTabType.TAB_LIBRARY
            ? 'bg-white border border-light-gray'
            : 'border-light-gray',
        ]"
        @click="setTab(FeedTabType.TAB_LIBRARY)"
      >
        {{ t("feed.tab.switch.library") }}
      </button>
    </div>
  </div>
</template>
<script setup lang="ts">
import { ref, defineEmits, watch } from "vue";
import { useI18n } from "vue-i18n";
import { FeedTabType } from "../../../enum/v2/feed-tab-type";

const { t } = useI18n();
const emit = defineEmits(["update:currentTab"]);
const props = defineProps<{ currentTab: FeedTabType }>();
const currentView = ref<FeedTabType>(props.currentTab);

function setTab(tab: FeedTabType) {
  currentView.value = tab;
  emit("update:currentTab", tab);
}

watch(
  () => props.currentTab,
  (val) => {
    currentView.value = val;
  }
);
</script>
